import React, { useEffect, useState } from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import deepEqual from 'deep-equal';
import './SmartXonnectLayout.scss';
import config from '../../../../temp/config';
import { Helmet } from 'react-helmet';
import { LayoutDetailsContext } from '../LayoutDetailsContext'; // adjust path
import PushDataLayerMCP from '../../../Foundation/Datalayer/PushDataLayerMCP';

// This is boilerplate navigation for sample purposes. Most apps should throw this away and use their own navigation implementation.
// Most apps may also wish to use GraphQL for their navigation construction; this sample does not simply to support disconnected mode.
const SmartXonnectLayout = ({ route }) => {
  const [opacity, setOpacity] = useState(0.05);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpacity(false);
    }, 150);

    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    PushDataLayerMCP('Vehicle Page', 'SmartXonnect', 'TVS iQube', 'Electric', 'EV');
  }, []);
  // console.log('route', route);

  return (
    <React.Fragment>
      {/* <Skeleton /> */}
      <div
        style={{
          opacity: opacity,
          transition: 'opacity 150ms',
        }}
        className="smart-xonnect-wrapper"
      >
        <Helmet>
          <title>{route?.fields?.PageTitle?.value || 'Tvs Motor'}</title>
          <link rel="preconnect" href="https://dynamic.criteo.com" crossOrigin="anonymous" />
          <link rel="preconnect" href="https://www.googleadservices.com" />
          <link rel="preconnect" href="https://adservice.google.com" />
          <link rel="preconnect" href="https://googleads.g.doubleclick.net" />
          <link rel="preconnect" href="https://www.googletagmanager.com" />
          <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
          <link rel="preconnect" href="https://fonts.googleapis.com" crossOrigin="anonymous" />
          <link rel="preconnect" href="https://cdn.evgnet.com" />
          <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />

          <link rel="dns-prefetch" href="https://cdn.evgnet.com" />
          <link rel="dns-prefetch" href="https://www.googleadservices.com" />
          <link rel="dns-prefetch" href="https://adservice.google.com" />
          <link rel="dns-prefetch" href="https://googleads.g.doubleclick.net" />
          <link rel="dns-prefetch" href="https://www.googletagmanager.com" />
          <link rel="dns-prefetch" href="https://dev.visualwebsiteoptimizer.com" />

          <script async type="text/javascript" src={config.evergageScriptUrl}></script>

          <meta charset="utf-8" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
          <meta name="description" content={route?.fields?.MetaDescription?.value} />
          <meta name="keywords" content={route?.fields?.MetaKeywords?.value} />
          <meta name="viewport" content={route?.fields?.MetaViewport?.value} />
          <meta property="og:title" content={route?.fields?.OgTitle?.value} />
          <meta property="og:description" content={route?.fields?.OgDescription?.value} />
          <meta property="og:image" content={route?.fields?.OgImage?.value} />
          <meta property="og:url" content={route?.fields?.OgUrl?.value} />
          <meta property="og:type" content={route?.fields?.OgType?.value} />
          <meta property="og:site_name" content={route?.fields?.OgSitename?.value} />
          <meta name="twitter:title" content={route?.fields?.TwitterTitle?.value} />
          <meta name="twitter:description" content={route?.fields?.TwitterDescription?.value} />
          <meta name="twitter:image" content={route?.fields?.TwitterImage?.value} />
          <meta name="twitter:site" content={route?.fields?.TwitterSite?.value} />
          <meta name="twitter:creator" content={route?.fields?.TwitterCreator?.value} />
          <meta name="twitter:card" content={route?.fields?.TwitterCard?.value} />
          <meta name="twitter:url" content={route?.fields?.TwitterUrl?.value} />
        </Helmet>
        <LayoutDetailsContext.Provider value="SmartXonnect">
          {route?.fields?.HideHeader?.value ? null : (
            <Placeholder name="jss-header" rendering={route} />
          )}
          <Placeholder name="jss-main" rendering={route} />
          {route?.fields?.HideFooter?.value ? null : (
            <Placeholder name="jss-footer" rendering={route} />
          )}
        </LayoutDetailsContext.Provider>
      </div>
    </React.Fragment>
  );
};

const propsAreEqual = (prevProps, nextProps) => {
  if (deepEqual(prevProps.route, nextProps.route)) return true;

  return false;
};

export default React.memo(SmartXonnectLayout, propsAreEqual);
